import React from "react";
import '../About.css'
import { Grid2, keyframes, Typography,Paper } from '@mui/material'
import { AboutHeroDesktop } from "./AboutHeroDesktop";
import { AboutVisionDesktop } from "./AboutVisionDesktop";
import { AboutInfoDesktop } from "./AboutInfoDesktop";

export const AboutDesktop = () => {
  return (
    <Grid2 container width="100% !important"  justifyContent="center" gap="50px">
      <AboutHeroDesktop/>
      
      <Grid2 className="info" container justifyContent="center">
        <Typography className="headingdata" >About us</Typography>
        <AboutInfoDesktop/>
      </Grid2>

      <AboutVisionDesktop/>

      <Grid2 className="info" container justifyContent="center" sx={{width:"100%",position:"relative",gap:"20px"}}>
        <Typography className="headingdata">What we do ?</Typography>
        <Grid2 width="90%" sx={{padding:"10px",margin:"10px 0px "}} >
          <Typography className="contentData" >"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dicta, ratione sint. Similique mollitia facere perspiciatis, repellat placeat corporis ex earum quia excepturi! Neque alias qui eveniet veritatis doloribus earum quia! Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit quibusdam sequi nihil est quaerat placeat officiis nam officia, exercitationem rem ex esse quo eum corrupti nobis fugiat laudantium aliquid quam."</Typography>
        </Grid2>
      </Grid2>

      <Grid2 className="info" container justifyContent="center" sx={{width:"100%",position:"relative",gap:"20px"}}>
        <Typography className="headingdata">What we are?</Typography>
        <Grid2 width="90%" sx={{padding:"10px",margin:"10px 0px "}} >
           <Typography className="contentData">"Lorem, ipsum dolor sit amet consectetur adipisicing elit. Dicta, ratione sint. Similique mollitia facere perspiciatis, repellat placeat corporis ex earum quia excepturi! Neque alias qui eveniet veritatis doloribus earum quia! Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit quibusdam sequi nihil est quaerat placeat officiis nam officia, exercitationem rem ex esse quo eum corrupti nobis fugiat laudantium aliquid quam."</Typography>
        </Grid2>
      </Grid2>

    </Grid2>
  );
};
